/**
 * 確認ダイアログ
 */

import { SCancelButton, SConfirmDialog, SNormalButton } from "components";
import { SDialog } from "components/parts";
import { labels } from "messages/labels";
import { useEffect, useState } from "react";

type Props = {
  msg: string;
  onOk: Function;
  isOpen: boolean;
} & Partial<{
  onCancel: Function;
  title: string;
}>;
export const SConfirmDialogAction = ({
  title = "　",
  msg,
  onCancel,
  onOk,
  isOpen,
}: Props): JSX.Element => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    onCancel?.call(null);
    setOpen(false);
  };
  const handleSubmit = () => {
    onOk();
    setOpen(false);
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <SDialog
      open={open}
      dialog={<SConfirmDialog title={title} msg={msg} />}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      action={
        <>
          <SCancelButton
            label={labels.buttons.cancel}
            onClick={() => {
              handleClose();
            }}
          />
          <SNormalButton label={labels.buttons.ok} onClick={handleSubmit} />
        </>
      }
    />
  );
};
